import { updateStepUpPassword } from "@/api/stepUp";
import { useMutation } from "@tanstack/react-query";

export const useUpdateStepUpPassword = () => {
  return useMutation({
    mutationFn: updateStepUpPassword,
  });
};
